import { render, staticRenderFns } from "./exchangeCoupon.vue?vue&type=template&id=18c55f94&scoped=true&"
import script from "./exchangeCoupon.vue?vue&type=script&lang=js&"
export * from "./exchangeCoupon.vue?vue&type=script&lang=js&"
import style0 from "./exchangeCoupon.vue?vue&type=style&index=0&id=18c55f94&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c55f94",
  null
  
)

export default component.exports